import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useZonesData } from '../hooks/useZonesData';
import { useToast } from '../hooks/useToast';
import { useZoneFilters } from '../hooks/useZoneFilters';
import { useZoneOperations } from '../hooks/useZoneOperations';
import Toast from '../components/common/Toast';
import AddZoneModal from '../components/zones/AddZoneModal';
import ZonesHeader from '../components/zones/ZonesHeader';
import ZonesFilters from '../components/zones/ZonesFilters';
import ZoneContent from '../components/zones/ZoneContent';
import ZonesStates from '../components/zones/ZonesStates';

const Zones: React.FC = () => {
  const {
    zones,
    setZones,
    providers,
    loading,
    error,
    zoneRecords,
    setZoneRecords,
    recordsLoading,
    recordsError,
    handleRefresh,
    loadZoneRecords,
  } = useZonesData();

  const [selectedZone, setSelectedZone] = useState<any>(null);
  const { toast, showToast } = useToast();
  
  const {
    searchTerm,
    setSearchTerm,
    selectedProvider,
    setSelectedProvider,
    showProviderFilter,
    handleToggleProviderFilter,
    handleClearFilters,
    filteredZones,
    isFiltered,
  } = useZoneFilters(zones);

  const {
    editingRecord,
    showNewRecord,
    showAddModal,
    newZone,
    editRecord,
    addRecord,
    updateRecord,
    deleteRecord,
    createRecord,
    bulkDelete,
    bulkUpdateTTL,
    addZone,
    updateNewZone,
    setEditingRecord,
    setShowNewRecord,
    setShowAddModal,
  } = useZoneOperations({
    selectedZone,
    loadZoneRecords,
    handleRefresh,
    showToast,
  });

  const handleZoneClick = (zone: any) => {
    setSelectedZone(zone);
    loadZoneRecords(zone.id);
  };

  const handleBackToZones = () => {
    setSelectedZone(null);
    setZoneRecords([]);
  };



  return (
    <ZonesStates loading={loading} error={error} onRefresh={handleRefresh}>
      <motion.div
        className="space-y-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Toast toast={toast} />

        <ZonesHeader
          onRefresh={handleRefresh}
          onAddZone={() => setShowAddModal(true)}
          onBack={selectedZone ? handleBackToZones : undefined}
          selectedZoneName={selectedZone?.name}
        />

        <ZonesFilters
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          selectedProvider={selectedProvider}
          onProviderChange={setSelectedProvider}
          showProviderFilter={showProviderFilter}
          onToggleProviderFilter={handleToggleProviderFilter}
          zones={zones}
          filteredZones={filteredZones}
        />

        <ZoneContent
          zones={zones}
          filteredZones={filteredZones}
          selectedZone={selectedZone}
          zoneRecords={zoneRecords}
          recordsLoading={recordsLoading}
          recordsError={recordsError}
          isFiltered={isFiltered}
          searchTerm={searchTerm}
          selectedProvider={selectedProvider}
          loading={loading}
          editingRecord={editingRecord}
          showNewRecord={showNewRecord}
          onZoneClick={handleZoneClick}
          onAddZone={() => setShowAddModal(true)}
          onClearFilters={handleClearFilters}
          onRefreshRecords={loadZoneRecords}
          onEditRecord={editRecord}
          onDeleteRecord={deleteRecord}
          onAddRecord={addRecord}
          onBulkDelete={bulkDelete}
          onBulkUpdateTTL={bulkUpdateTTL}
          onUpdateRecord={updateRecord}
          onCreateRecord={createRecord}
          onCancelEdit={() => setEditingRecord(null)}
          onCancelNew={() => setShowNewRecord(false)}
        />

        <AddZoneModal
          showModal={showAddModal}
          newZone={newZone}
          providers={providers}
          onClose={() => setShowAddModal(false)}
          onSubmit={addZone}
          onInputChange={updateNewZone}
        />
      </motion.div>
    </ZonesStates>
  );
};

export default Zones;
